import { Outlet } from "react-router-dom";
import useInactivityTimeout from "../../pages/useInactivityTimeout";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const DefultLayout1 = () => {
  const { showDialog, handleStayLoggedIn, handleLogout, countdown } =
    useInactivityTimeout(300 * 1000, 270 * 1000);

  return (
    <>
      <Outlet />
      {localStorage.getItem("code-verified") && (
        <Dialog
          open={showDialog}
          aria-labelledby="inactivity-dialog-title"
          PaperProps={{
            style: {
              borderRadius: "12px",
              minWidth: "400px",
            },
          }}
        >
          <DialogTitle
            id="inactivity-dialog-title"
            sx={{
              p: "12px 24px",
              borderBottom: "1px solid #dee2e6",
            }}
          >
            <h3 className="mb-0">Session Timeout Warning</h3>
          </DialogTitle>
          <DialogContent sx={{ p: 3, pt: 3 }} className="pt-3">
            <p className="mb-0">
              You will be logged out automatically in{" "}
              <strong>{countdown}</strong> seconds. Do you want to stay logged
              in or log out?
            </p>
          </DialogContent>
          <DialogActions
            sx={{ p: "12px 24px", borderTop: "1px solid #dee2e6" }}
          >
            <Button onClick={handleStayLoggedIn} variant="contained">
              Stay Logged In
            </Button>
            <Button onClick={handleLogout} variant="contained" color="error">
              Logout
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default DefultLayout1;
